import React from 'react';
import Contact from '../Components/ContactComponent/Contact';
import Header from '../Components/GlobalComponent/Header';
import Footer from '../Components/GlobalComponent/Footer';
import Banner from '../Components/AboutComponent/Banner';
import About from '../Components/AboutComponent/About';
import PostsCom from '../Components/PostsCom';
    
const Posts = () => {
    return (
        <div>
            <Header/>
            <Banner/>
            <PostsCom/>
            <About/>
            <Footer/>
        </div>
    );
};

export default Posts;
